import { render, staticRenderFns } from "./recipients.vue?vue&type=template&id=7145ccec&scoped=true&"
import script from "./recipients.vue?vue&type=script&lang=js&"
export * from "./recipients.vue?vue&type=script&lang=js&"
import style0 from "./recipients.vue?vue&type=style&index=0&id=7145ccec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7145ccec",
  null
  
)

export default component.exports